module.exports = __webpack_public_path__ + "static/media/icon_check.3e5d0423.svg";